import React from "react";

const DividerIcon = (props) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" width={34} height={4} viewBox="0 0 34 4" {...props}>
    <defs>
      <rect id="a" width={180} height={41} y={10} rx={4} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-136 -29)">
        <use fill="#FFF" xlinkHref="#a" />
        <rect width={179} height={40} x={0.5} y={10.5} stroke="#F2F2F2" rx={4} />
      </g>
      <g fill="currentColor" fillRule="nonzero">
        <path d="M3.89 1.617L2.474.203a.5.5 0 0 0-.707 0L.354 1.617a.5.5 0 0 0 0 .707l1.414 1.414a.5.5 0 0 0 .707 0l1.414-1.414a.5.5 0 0 0 0-.707zm29.698 0L32.173.203a.5.5 0 0 0-.707 0l-1.414 1.414a.5.5 0 0 0 0 .707l1.414 1.414a.5.5 0 0 0 .707 0l1.415-1.414a.5.5 0 0 0 0-.707z" />
        <path d="M3.182 2.324a.5.5 0 0 1 .353-.853h26.87a.5.5 0 0 1 0 1H3.535a.498.498 0 0 1-.353-.147z" />
      </g>
    </g>
  </svg>
);

export default DividerIcon;
